export function pasteHtmlAtCaret(html, selectPastedContent) {
  let sel, range;
  if (window.getSelection) {
    // IE9 and non-IE
    sel = window.getSelection()
    if (sel.getRangeAt && sel.rangeCount) {
      range = sel.getRangeAt(0);
      range.deleteContents();

      // Range.createContextualFragment() would be useful here but is
      // only relatively recently standardized and is not supported in
      // some browsers (IE9, for one)
      const el = document.createElement('div');
      el.innerHTML = html;
      const frag = document.createDocumentFragment()
      let node
      let lastNode
      while ( (node = el.firstChild) ) {
        lastNode = frag.appendChild(node);
      }
      const firstNode = frag.firstChild;
      range.insertNode(frag);

      // Preserve the selection
      if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        if (selectPastedContent) {
          range.setStartBefore(firstNode);
        } else {
          range.collapse(true);
        }
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  } else if ( document.selection && document.selection.type !== 'Control') {
    // IE < 9
    sel = document.selection
    const originalRange = sel.createRange();
    originalRange.collapse(true);
    sel.createRange().pasteHTML(html);
    if (selectPastedContent) {
      range = sel.createRange();
      range.setEndPoint('StartToStart', originalRange);
      range.select();
    }
  }
}


function getNodeIndex(n){let i=0;while(n= n && n.previousSibling)i++;return i}

export function saveSelection(bE) {
  const range=window.getSelection().getRangeAt(0);
  let sC=range.startContainer
  let eC=range.endContainer;

  const A=[];
  while(sC && sC!==bE){A.push(getNodeIndex(sC));sC=sC.parentNode}
  const B=[];
  while(eC && eC!==bE){B.push(getNodeIndex(eC));eC=eC.parentNode}
  return {'sC':A,'sO':range.startOffset,'eC':B,'eO':range.endOffset};
}

export function restoreSelection(bE, rp) {
  bE.focus();
  const sel=window.getSelection()
  const range=sel.getRangeAt(0);
  let x
  let C
  let sC=bE
  let eC=bE
  C=rp.sC;x=C.length;
  while(x--){
    const tmp = sC.childNodes[C[x]]
    if(tmp)
      sC = tmp
  }
  C=rp.eC;x=C.length;
  while(x--){
    const tmp = eC.childNodes[C[x]];
    if(tmp)
      eC = tmp
  }
  try {
    range.setStart(sC, rp.sO);
  } catch(e) {
    console.error(e)
  }
  try {
    range.setEnd(eC, rp.eO);
  } catch(e) {
    console.error(e)
  }
  sel.removeAllRanges();
  sel.addRange(range)
}

export function pasteTextAtCaret(text) {
  let sel, range;
  if (window.getSelection) {
    sel = window.getSelection();
    if (sel.getRangeAt && sel.rangeCount) {
      range = sel.getRangeAt(0);
      range.deleteContents();
      range.insertNode( document.createTextNode(text) );
      for(let i = 0; i < text.length - 1; i++) {
        sel.modify('move', 'right', 'character')
      }
    }
  } else if (document.selection && document.selection.createRange) {
    document.selection.createRange().text = text;
  }
}
